import { render, staticRenderFns } from "./SlideShow.vue?vue&type=template&id=4f298c65&scoped=true&"
import script from "./slideshow.js?vue&type=script&lang=js&"
export * from "./slideshow.js?vue&type=script&lang=js&"
import style0 from "./SlideShow.vue?vue&type=style&index=0&id=4f298c65&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f298c65",
  null
  
)

export default component.exports